import mqtt, { IClientSubscribeOptions, MqttClient } from "mqtt";
// import { $t, transformI18n } from "@/plugins/i18n";
const mqttUrl = import.meta.env.VITE_MQTT_HOST;
const username = import.meta.env.VITE_MQTT_USER;
const password = import.meta.env.VITE_MQTT_PASSWORD;
let elNotificationArr: any = [];
export const getElNotificationArr = () => {
  return elNotificationArr;
};
export const setElNotificationArr = (newArr: any) => {
  elNotificationArr = newArr;
};

export interface MqttInfo {
  client: MqttClient | null;
  topicNotice: string;
  topicMessage: string;
  topicVoice: string;
  connectTimeout: number; // 超时时间
  reconnectPeriod: number; // 重连时间间隔
  qos: IClientSubscribeOptions; // 服务质量
  // clean: boolean; // 保留会话
  // 认证信息
  clientId: string;
  username: string;
  password: string;
}

const mqttInfo: MqttInfo = {
  client: null,
  connectTimeout: 5000,
  reconnectPeriod: 2000,
  clientId: "",
  qos: { qos: 1 },
  topicNotice: "",
  topicMessage: "",
  topicVoice: "",
  username,
  password,
};

export function initMqtt(tenantId, userId) {
  const topicNotice = `/deviceAlarm/notices/${tenantId}/${userId}`;
  mqttInfo.topicNotice = topicNotice;
  mqttInfo.topicMessage = topicNotice;
  mqttInfo.topicVoice = topicNotice;

  const options = {
    reconnectPeriod: mqttInfo.reconnectPeriod,
    connectTimeout: mqttInfo.connectTimeout,
    username: mqttInfo.username,
    password: mqttInfo.password,
    // keepalive: 0,
    clientId: "mqtt_client_" + "cems" + "_" + Math.random(),
    // host: mqttInfo.url,
    // port: mqttInfo.port,
    // protocol: "ws",
  };
  // 连接字符串, 通过协议指定使用的连接方式
  // ws 未加密 WebSocket 连接
  // wss 加密 WebSocket 连接
  // mqtt 未加密 TCP 连接
  // mqtts 加密 TCP 连接
  const isProd = false;
  mqttInfo.client = mqtt.connect(
    `${isProd ? "wss" : "ws"}://${mqttUrl}/mqtt`,
    options,
  );
  mqttInfo.client?.on("connect", function () {});
  //如果连接错误，打印错误
  mqttInfo.client?.on("error", function (err: any) {});
}

export function mqttReceive({ setAlarmNum, setAlarmList }) {
  mqttInfo.client?.subscribe(
    mqttInfo.topicNotice,
    mqttInfo.qos,
    function (err: any) {
      // success
      if (!err) {
        mqttInfo.client?.on(
          "message",
          function (topic: any, receivedMessage: Map<string, any>) {
            if (topic != mqttInfo.topicNotice) return;
            const tmpStr = receivedMessage.toString();

            const item = JSON.parse(tmpStr);
            // refreshNoticeNum();
            let showingNum = 0;
            const currentItemWithDisplay = item;
            setAlarmNum((showingNum += 1));
            setAlarmList(currentItemWithDisplay);
          },
        );
        // error
      } else {
        //打印错误
      }
    },
  );

  // ----------------- type用于快速定位类型，
  mqttInfo.client?.subscribe(
    mqttInfo.topicMessage,
    mqttInfo.qos,
    function (err: any) {
      if (!err) {
        mqttInfo.client?.on(
          "message",
          function (topic: any, receivedMessage: Map<string, any>) {
            if (topic != mqttInfo.topicMessage) return;
            const tmpStr = receivedMessage.toString();
            const item = JSON.parse(tmpStr);
            const alarmInfo = new Function("return " + item.message)();
          },
        );
        // error
      } else {
        //打印错误
        console.log("err", err);
      }
    },
  );

  // -------------------

  mqttInfo.client?.subscribe(
    mqttInfo.topicVoice,
    mqttInfo.qos,
    function (err: any) {
      // success
      if (!err) {
        // console.log('subscribe success!');
        mqttInfo.client?.on(
          "message",
          function (topic: any, receivedMessage: Map<string, any>) {
            if (topic != mqttInfo.topicVoice) return;
            const tmpStr = receivedMessage.toString();
            const item = JSON.parse(tmpStr);
            // console.log(tmpStr, " !!! ", topic);
          },
        );
        // error
      } else {
        //打印错误
        // console.log("err", err);
      }
    },
  );
  // -----------------
  mqttInfo.client?.disconnected;
}

export function destroyConnection() {
  if (mqttInfo.client?.connected) {
    try {
      mqttInfo.client?.end();
      mqttInfo.client = null;
      // console.log("Successfully disconnected!");
    } catch (error) {
      // console.log("Disconnect failed", error.toString());
    }
  }
}
